import { isFilenameSearchActive } from '@/lib/photos/filename-search'
import type { PhotosFilterTriState } from '@/lib/photos/types/photos-filter-tri-state'
import type { PhotosOrientationFilter } from '@/lib/photos/types/photos-orientation-filter'
import type { PhotosPanelActiveFiltersInput } from './types/photos-panel-active-filters-input'
import type { PhotosPanelClearedFilters } from './types/photos-panel-cleared-filters'

function isNonDefaultFilter(value: PhotosFilterTriState | PhotosOrientationFilter): boolean {
  return value !== 'any'
}

/**
 * Counts active Filters-badge selections: each topic/student id, plus one each for
 * filename / placed / tagged / favorited / orientation when not at default.
 */
export function countActiveFilters(input: PhotosPanelActiveFiltersInput): number {
  let count = input.topicTagIds.length + input.studentIds.length

  if (isFilenameSearchActive(input.filenameQuery)) {
    count += 1
  }

  if (isNonDefaultFilter(input.placed)) count += 1
  if (isNonDefaultFilter(input.tagged)) count += 1
  if (isNonDefaultFilter(input.favorited)) count += 1
  if (isNonDefaultFilter(input.orientation)) count += 1

  return count
}

/** Defaults after Clear filters (topics, students, filename, ternary dims, orientation). */
export function createClearedPhotosPanelFilters(): PhotosPanelClearedFilters {
  return {
    topicTagIds: [],
    studentIds: [],
    filenameQuery: '',
    placed: 'any',
    tagged: 'any',
    favorited: 'any',
    orientation: 'any',
  }
}
